function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "#FC5A5A"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.6666 18H9.1111C7.39289 18 6 16.6071 6 14.8889V11.3333C6 9.88743 6.98637 8.6719 8.32292 8.32293C8.67189 6.98637 9.88741 6.00001 11.3333 6.00001H14.8889C16.6071 6.00001 18 7.3929 18 9.11112V12.6667C18 14.1126 17.0136 15.3281 15.677 15.6771C15.3281 17.0136 14.1125 18 12.6666 18ZM14.704 15.7778C14.361 16.5626 13.5779 17.1111 12.6666 17.1111H9.1111C7.88381 17.1111 6.88889 16.1162 6.88889 14.8889V11.3333C6.88889 10.4221 7.43737 9.63894 8.22221 9.29602V12.6667C8.22221 14.3849 9.6151 15.7778 11.3333 15.7778H14.704ZM11.3333 14.8889C10.106 14.8889 9.1111 13.894 9.1111 12.6667V9.11112C9.1111 7.88382 10.106 6.8889 11.3333 6.8889H14.8889C16.1162 6.8889 17.1111 7.88382 17.1111 9.11112V12.6667C17.1111 13.894 16.1162 14.8889 14.8889 14.8889H11.3333Z",
  fill: "white"
});

var SvgCopy = function SvgCopy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCopy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/copy.508b6df3.svg";
export { ForwardRef as ReactComponent };